import styled from 'styled-components'

import { AgreedForm as CommonAgreedForm, Input as CommonInput } from 'primsell-shared-layer/components'

export const Input = styled(CommonInput)`
  margin-bottom: 24px;
`

export const AgreedForm = styled(CommonAgreedForm)`
  margin-bottom: 24px;
`
